module.exports = __webpack_public_path__ + "media/images/icon__settings@3x-93f36abbf5852999fa29e18b7a753811.png";